import type { TSearchPerformer } from 'homesearch-vue-property/dist/types/location-search';

enum ESearchResultType {
  DISTRICT = 'district',
  SECTOR = 'sector',
  POSTCODE = 'postcode',
}

interface ILocationSearchResult {
  full_address: string;
  type: ESearchResultType; // depends on included types. TODO: improve interface so each context can hint expected types
}

export type { TSearchPerformer, ILocationSearchResult };

export { ESearchResultType };
